<div class="wrapper">
  <header class="header">
    <nav class="vam-navbar">
      <div class="container">
        <div class="vam_login_nav">
          <div class="vam_nav_brand">
            <a class="navbar-brand d-flex align-items-center company-logo" routerLink="/">
              <img src="/assets/images/logo.png" alt="Logo" width="30px" height="30px" />
            </a>
            <a href="javascript:void(0)" class="d-inline-block" (click)="location.back()">
              <img src="/assets/images/back.svg" class="vam_back" />
            </a>
          </div>
          <div class="vam_nav_logout">
            <a href="javascript:void(0)" (click)="logout()">
              <img src="/assets/images/logout2.svg" />
            </a>
          </div>
        </div>
      </div>
    </nav>
  </header>

  <main class="main wrapper__main validation">
    <section class="vam_validation_section my-5">
      <div class="container">
        <div class="vam_validation_form_container">
          <div class="vam_validation_title_container text-center mb-5">
            <h1 class="vam_validation_title">
              {{ 'validation.validation' | translate }}
            </h1>
          </div>

          <form
            class="vam_validation_form credential2 px-3"
            [formGroup]="validation"
            #validationFormDirective
            (submit)="validate()"
          >
            <div
              class="preview-container"
              *ngIf="fileBase64 || file2Base64 || file3Base64 || file4Base64 || file5Base64"
            >
              <div class="row mx-n2">
                <div class="col-6 col-md-3 px-2" *ngIf="file || fileBase64">
                  <span class="d-flex fs fs__sm mb-1 color-navy-d">VIN Image</span>
                  <a
                    href="javascript:void(0)"
                    #vinPrev
                    class="validation-preview mb-2 mb-md-0"
                    [class.untouchable]="!file && !fileBase64"
                  >
                    <img [src]="fileBase64" alt="" class="preview-img" />
                  </a>
                </div>
                <div class="col-6 col-md-3 px-2" *ngIf="file2 || file2Base64">
                  <span class="d-flex fs fs__sm mb-1 color-navy-d">Plate Image</span>
                  <a
                    href="javascript:void(0)"
                    #platePrev
                    class="validation-preview mb-2 mb-md-0"
                    [class.untouchable]="!file2 && !file2Base64"
                  >
                    <img [src]="file2Base64" alt="" class="preview-img" />
                  </a>
                </div>
                <div class="col-6 col-md-3 px-2" *ngIf="file3 || file3Base64">
                  <span class="d-flex fs fs__sm mb-1 color-navy-d">Odo Image</span>
                  <a
                    href="javascript:void(0)"
                    #odoPrev
                    class="validation-preview mb-2 mb-md-0"
                    [class.untouchable]="!file3 && !file3Base64"
                  >
                    <img [src]="file3Base64" alt="" class="preview-img" />
                  </a>
                </div>
                <div class="col-6 col-md-3 px-2" *ngIf="file4 || file4Base64">
                  <span class="d-flex fs fs__sm mb-1 color-navy-d">RC Image</span>
                  <a
                    href="javascript:void(0)"
                    #estemaraPrev
                    class="validation-preview mb-2 mb-md-0"
                    [class.untouchable]="!file4 && !file4Base64"
                  >
                    <img [src]="file4Base64" alt="" class="preview-img" />
                  </a>
                </div>
                <div class="col-6 col-md-3 px-2 mt-md-2" *ngIf="file5 || file5Base64">
                  <span class="d-flex fs fs__sm mb-1 color-navy-d">MVPI Image</span>
                  <a
                    href="javascript:void(0)"
                    #mvpiPrev
                    class="validation-preview mb-2 mb-md-0"
                    [class.untouchable]="!file5 && !file5Base64"
                  >
                    <img [src]="file5Base64" alt="" class="preview-img" />
                  </a>
                </div>
              </div>
            </div>

            <div class="row mx-n2 mb-md-0 mb-3">
              <div class="col-md-1 col-2 px-2">
                <div class="credential2__checkGroup">
                  <input
                    type="checkbox"
                    name="vin_confirm"
                    formControlName="vin_confirm"
                    class="credential2__check"
                    id="vin_confirm"
                  />
                  <label
                    for="vin_confirm"
                    class="credential2__checkLabel"
                    [class.invalid]="formData.vin_confirm.invalid && submitted"
                    required
                  >
                  </label>
                </div>
              </div>

              <div class="col-md-6 col-10 px-2">
                <div class="form-group vam_validation_input_wraper">
                  <input
                    type="text"
                    name="vin"
                    formControlName="vin"
                    [placeholder]="'vin_number' | translate"
                    class="form-control credential2__input"
                    [class.is-invalid]="formData.vin.invalid && this.submitted"
                  />

                  <div class="form-errors" *ngIf="formData.vin.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.vin.errors.required">
                      VIN no. is required.
                    </p>

                    <p class="form-errors__error" *ngIf="formData.vin.errors.maxlength">
                      VIN no. should not be more than 21 characters.
                    </p>

                    <p class="form-errors__error" *ngIf="formData.vin.errors.pattern">
                      VIN no. should be alphanumerical only.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-5 px-2">
                <div class="form-group w-100">
                  <label
                    for="vin"
                    class="btn btn__secondary text-truncate"
                    [class.invalid_btn]="formData.vin_img.invalid && submitted"
                  >
                    <img src="assets/images/vam_camera.svg" class="validation_icon mr-2" />
                    <span class="validation_title text-truncate">
                      {{ 'validation.take_vin_image' | translate }}
                    </span>
                  </label>
                  <input
                    type="file"
                    class="code_fileInput"
                    id="vin"
                    accept="image/*"
                    capture="camera"
                    (change)="File($event, 'vin')"
                  />
                  <div class="form-errors" *ngIf="formData.vin_img.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.vin_img.errors.required">
                      Vin image is required.
                    </p>
                  </div>

                  <div class="form-errors" *ngIf="extErrorFile && this.file">
                    <p class="form-errors__error">Only '.png', '.jpg' or '.jpeg' is supported.</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-n2 mb-md-0 mb-3">
              <div class="col-md-1 col-2 px-2">
                <div class="credential2__checkGroup">
                  <input
                    type="checkbox"
                    name="plate_confirm"
                    formControlName="plate_confirm"
                    class="credential2__check"
                    id="plate_confirm"
                  />
                  <label
                    for="plate_confirm"
                    class="credential2__checkLabel"
                    [class.invalid]="formData.plate_confirm.invalid && submitted"
                    required
                  >
                  </label>
                </div>
              </div>

              <div class="col-md-6 col-10 px-2">
                <div class="form-group vam_validation_input_wraper">
                  <input
                    type="text"
                    name="plate"
                    formControlName="plate"
                    [placeholder]="'plate_number' | translate"
                    class="form-control credential2__input"
                    [class.is-invalid]="formData.plate.invalid && this.submitted"
                  />

                  <div class="form-errors" *ngIf="formData.plate.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.plate.errors.required">
                      Plate no. is required.
                    </p>

                    <p class="form-errors__error" *ngIf="formData.plate.errors.pattern">
                      Plate no. should be alphanumerical only.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-5 px-2">
                <div class="form-group w-100">
                  <label
                    for="plate"
                    class="btn btn__secondary text-truncate"
                    [class.invalid_btn]="formData.plate_img.invalid && submitted"
                  >
                    <img src="assets/images/vam_camera.svg" class="validation_icon mr-2" />
                    <span class="validation_title text-truncate">{{
                      'validation.take_plate_image' | translate
                    }}</span>
                  </label>
                  <input
                    type="file"
                    class="code_fileInput"
                    id="plate"
                    accept="image/*"
                    capture="camera"
                    (change)="File($event, 'plate')"
                  />

                  <div class="form-errors" *ngIf="formData.plate_img.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.plate_img.errors.required">
                      Plate image is required.
                    </p>
                  </div>

                  <div class="form-errors" *ngIf="extErrorFile2 && this.file2">
                    <p class="form-errors__error">Only '.png', '.jpg' or '.jpeg' is supported.</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-n2 mb-md-0 mb-3">
              <div class="col-md-1 col-2 px-2">
                <div class="credential2__checkGroup">
                  <input
                    type="checkbox"
                    name="odo_confirm"
                    formControlName="odo_confirm"
                    class="credential2__check"
                    id="odo_confirm"
                  />
                  <label
                    for="odo_confirm"
                    class="credential2__checkLabel"
                    [class.invalid]="formData.odo_confirm.invalid && submitted"
                    required
                  >
                  </label>
                </div>
              </div>

              <div class="col-md-6 col-10 px-2">
                <div class="form-group vam_validation_input_wraper">
                  <input
                    type="text"
                    name="odo"
                    formControlName="odo"
                    placeholder="Odo"
                    class="form-control credential2__input"
                    [class.is-invalid]="formData.odo.invalid && this.submitted"
                  />

                  <div class="form-errors" *ngIf="formData.odo.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.odo.errors.required">
                      Odo is required.
                    </p>

                    <p class="form-errors__error" *ngIf="formData.odo.errors.pattern">
                      Odo should be numerical only.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-5 px-2">
                <div class="form-group w-100">
                  <label
                    for="odo"
                    class="btn btn__secondary text-truncate"
                    [class.invalid_btn]="formData.odo_img.invalid && submitted"
                  >
                    <img src="assets/images/vam_camera.svg" class="validation_icon mr-2" />
                    <span class="validation_title text-truncate">Take Odo Image</span>
                  </label>
                  <input
                    type="file"
                    class="code_fileInput"
                    id="odo"
                    accept="image/*"
                    capture="camera"
                    (change)="File($event, 'odo')"
                  />

                  <div class="form-errors" *ngIf="formData.odo_img.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.odo_img.errors.required">
                      Odo image is required.
                    </p>
                  </div>

                  <div class="form-errors" *ngIf="extErrorFile3 && this.file3">
                    <p class="form-errors__error">Only '.png', '.jpg' or '.jpeg' is supported.</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-n2 mb-md-0 mb-3">
              <div class="col-md-1 col-2 px-2">
                <div class="credential2__checkGroup">
                  <input
                    type="checkbox"
                    name="estemara_confirm"
                    formControlName="estemara_confirm"
                    class="credential2__check"
                    id="estemara_confirm"
                  />
                  <label
                    for="estemara_confirm"
                    class="credential2__checkLabel"
                    [class.invalid]="formData.estemara_confirm.invalid && submitted"
                    required
                  >
                  </label>
                </div>
              </div>

              <div class="col-md-6 col-10 px-2">
                <div class="form-group">
                  <div class="datePicker-group">
                    <input
                      type="text"
                      name="est_exp_date"
                      formControlName="est_exp_date"
                      [placeholder]="'validation.estimara_expiry_date' | translate"
                      class="form-control credential2__input"
                      [class.is-invalid]="formData.est_exp_date.invalid && this.submitted"
                      readonly
                      bsDatepicker
                      [bsConfig]="dpConfig"
                      *ngIf="!estExpToggle"
                    />

                    <input
                      type="text"
                      name="est_exp_date"
                      formControlName="est_exp_date"
                      [placeholder]="'validation.estimara_expiry_date' | translate"
                      class="form-control credential2__input"
                      [class.is-invalid]="formData.est_exp_date.invalid && this.submitted"
                      id="est_exp_date"
                      autocomplete="off"
                      *ngIf="estExpToggle"
                    />

                    <button
                      type="button"
                      class="btn btn__action dpToggle p-0 mx-auto mb-3"
                      (click)="dpToggle('estemara')"
                    >
                      <span class="text-truncate" *ngIf="!estExpToggle">Ar</span>
                      <span class="text-truncate" *ngIf="estExpToggle">En</span>
                    </button>
                  </div>

                  <div class="form-errors" *ngIf="formData.est_exp_date.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.est_exp_date.errors.required">
                      RC expiry date is required.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-5 px-2">
                <div class="form-group w-100">
                  <label
                    for="estimara"
                    class="btn btn__secondary text-truncate"
                    [class.invalid_btn]="formData.est_img.invalid && submitted"
                  >
                    <img src="assets/images/vam_camera.svg" class="validation_icon mr-2" />
                    <span class="validation_title text-truncate">{{
                      'validation.take_estemara_image' | translate
                    }}</span>
                  </label>
                  <input
                    type="file"
                    class="code_fileInput"
                    id="estimara"
                    accept="image/*"
                    capture="camera"
                    (change)="File($event, 'istimara')"
                  />
                  <div class="form-errors" *ngIf="formData.est_img.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.est_img.errors.required">
                      RC image is required.
                    </p>
                  </div>

                  <div class="form-errors" *ngIf="extErrorFile4 && this.file4">
                    <p class="form-errors__error">Only '.png', '.jpg' or '.jpeg' is supported.</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-n2 mb-md-0 mb-3">
              <div class="col-md-1 col-2 px-2">
                <div class="credential2__checkGroup">
                  <input
                    type="checkbox"
                    name="mvpi_confirm"
                    formControlName="mvpi_confirm"
                    class="credential2__check"
                    id="mvpi_confirm"
                  />
                  <label
                    for="mvpi_confirm"
                    class="credential2__checkLabel"
                    [class.invalid]="formData.mvpi_confirm.invalid && submitted"
                    required
                  >
                  </label>
                </div>
              </div>

              <div class="col-md-6 col-10 px-2">
                <div class="form-group">
                  <div class="datePicker-group">
                    <input
                      type="text"
                      name="mvpi_exp_date"
                      formControlName="mvpi_exp_date"
                      [placeholder]="'validation.MVPI_expiry_date' | translate"
                      class="form-control credential2__input"
                      [class.is-invalid]="formData.mvpi_exp_date.invalid && this.submitted"
                      readonly
                      bsDatepicker
                      [bsConfig]="dpConfig"
                      *ngIf="!mvpiExpToggle"
                    />

                    <input
                      type="text"
                      name="mvpi_exp_date"
                      formControlName="mvpi_exp_date"
                      [placeholder]="'validation.MVPI_expiry_date' | translate"
                      class="form-control credential2__input"
                      [class.is-invalid]="formData.mvpi_exp_date.invalid && this.submitted"
                      id="mvpi_exp_date"
                      autocomplete="off"
                      *ngIf="mvpiExpToggle"
                    />

                    <button
                      type="button"
                      class="btn btn__action dpToggle p-0 mx-auto mb-3"
                      (click)="dpToggle('mvpi')"
                    >
                      <span class="text-truncate" *ngIf="!mvpiExpToggle">Ar</span>
                      <span class="text-truncate" *ngIf="mvpiExpToggle">En</span>
                    </button>
                  </div>

                  <div class="form-errors" *ngIf="formData.mvpi_exp_date.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.mvpi_exp_date.errors.required">
                      MVPI expiry date is required.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-5 px-2">
                <div class="form-group w-100">
                  <label
                    for="mvpi"
                    class="btn btn__secondary text-truncate"
                    [class.invalid_btn]="formData.mvpi_img.invalid && submitted"
                  >
                    <img src="assets/images/vam_camera.svg" class="validation_icon mr-2" />
                    <span class="validation_title text-truncate">{{
                      'validation.take_mvpi_image' | translate
                    }}</span>
                  </label>
                  <input
                    type="file"
                    class="code_fileInput"
                    id="mvpi"
                    accept="image/*"
                    capture="camera"
                    (change)="File($event, 'MVPI')"
                  />

                  <div class="form-errors" *ngIf="formData.mvpi_img.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.mvpi_img.errors.required">
                      Mvpi image is required.
                    </p>
                  </div>

                  <div class="form-errors" *ngIf="extErrorFile5 && this.file5">
                    <p class="form-errors__error">Only '.png', '.jpg' or '.jpeg' is supported.</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-8 col-sm-9 mx-auto mt-4">
              <button class="btn btn-primary w-100 py-2" [disabled]="submitLoad">
                {{ 'submit' | translate }}
                <span class="spinner-grow spinner-grow-sm text-light ml-2" [hidden]="!submitLoad">
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </main>
</div>
<app-status></app-status>
